function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// 行政区划字典：保留完整省市区路径，并兼容两位省、四位市的查询前缀。
export function buildRegionIndex(source) {
  var result = {
    names: {},
    paths: {},
    prefixes: {},
    options: []
  };
  var _unwrap = function unwrap(value) {
    return Array.isArray(value) ? value : value && (value.list || value.data) ? _unwrap(value.list || value.data) : [];
  };
  var _visit = function visit(nodes) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var ids = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return _unwrap(nodes).map(function (node) {
      var raw = node.regionId != null ? node.regionId : node.id;
      if (raw == null) return null;
      var id = String(raw);
      var name = node.regionName || node.name || node.label || '';
      var path = [].concat(_toConsumableArray(parents), [name]).filter(Boolean);
      var keys = [].concat(_toConsumableArray(ids), [id]);
      var depth = keys.length;
      var prefix = /^\d{6}$/.test(id) && depth < 3 ? id.slice(0, depth * 2) : id;
      [id, prefix].forEach(function (key) {
        result.names[key] = path.join(' / ');
        result.paths[key] = keys;
        result.prefixes[key] = prefix;
      });
      var item = {
        value: id,
        label: name
      };
      var children = node.child || node.children;
      if (depth < 3 && Array.isArray(children) && children.length) item.children = _visit(children, path, keys);
      return item;
    }).filter(Boolean);
  };
  result.options = _visit(source);
  return result;
}
export function regionLabel(index, code) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var key = code == null ? '' : String(code).trim();
  var name = index.names[key];
  if (name) return name;
  var text = fallback == null ? '' : String(fallback).trim();
  // 历史 regionPath 有的存名称，有的存编码串，不能把编码串当名称。
  if (text && !/^[\d\s,，/|-]+$/.test(text)) return text;
  return key ? "\u533A\u57DF\u540D\u79F0\u5F85\u5B8C\u5584\uFF08".concat(key, "\uFF09") : '未设置区域';
}